const GUEST_ID_KEY = 'emotion_guest_id';

export function getOrCreateGuestIdentifier(): string {
  let guestId = localStorage.getItem(GUEST_ID_KEY);
  
  if (!guestId) {
    // Generate a UUID-like identifier
    guestId = 'guest_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem(GUEST_ID_KEY, guestId);
  }
  
  return guestId;
}

export function clearGuestIdentifier(): void {
  localStorage.removeItem(GUEST_ID_KEY);
}

export function hasGuestIdentifier(): boolean {
  return localStorage.getItem(GUEST_ID_KEY) !== null;
} 